<template>
  <div id="Element_extraction">
    <div class="font">
      <span class="introSubTitle"><b>遥感典型地理要素提取系统</b></span>
      <p class="textStyle">本系统将遥感提取技术与人工智能手段相结合，具备多源遥感数据融合处理、信息增强、图像分割、目标信息提取、知识库管理等功能，系统采用模块化开发，算法可以灵活添加扩展，能支持水体、道路、建筑物、耕地等要素的智能提取。</p>
    </div>
    <!-- <br/>   -->
    <el-row :gutter="10">
      <el-col :span="8">
        <img
            width="100%"
            src="@/assets/img/scientific/Element_extraction-1.png"
        />
        <p class="img_figure">道路提取</p>
      </el-col>
      <el-col :span="8">
        <img
            width="100%"
            src="@/assets/img/scientific/Element_extraction-2.png"
        />
        <p class="img_figure">耕地提取</p>
      </el-col>
      <el-col :span="8">
        <img
            width="100%"
            src="@/assets/img/scientific/Element_extraction-3.png"
        />
        <p class="img_figure">水体提取</p>
      </el-col>
    </el-row>

    <el-row :gutter="10">
      <el-col :span="8">
        <img
            width="100%"
            src="@/assets/img/scientific/Element_extraction-5.jpg"
        />
        <p class="img_figure">建筑物提取</p>
      </el-col>
      <el-col :span="8">
        <img
            width="100%"
            src="@/assets/img/scientific/Element_extraction-4.jpg"
        />
        <p class="img_figure">舰船检测</p>
      </el-col>
      <el-col :span="8">
        <img
            width="100%"
            src="@/assets/img/scientific/Element_extraction-6.jpg"
        />
        <p class="img_figure">飞机检测</p>
      </el-col>
    </el-row>

    <!-- <div class="container">
      <my-video :sources="video.sources" :options="video.options"></my-video>
    </div> -->
  </div>
</template>

<script>
// import myVideo from "vue-video";

export default {
  data() {
    return {
      // video: {
      //   sources: [
      //     {src: require("@/assets/static/Element_extraction.mp4"), type:"video/mp4"},
      //   ],
      //   options: {
      //     autoplay: true,
      //     volume: 0.6,
      //   },
      // },
    };
  },
  // components: {
  //   myVideo,
  // },
};
</script>

<style lang="less">
#Element_extraction {
  margin-top: 20px;
  .img_figure{
    display: flex;
    justify-content: center;
    font-size: 14px;
    color: #4f4f4f;
  }
  // .font {
  //   // font-family: "Times New Roman", Times, serif;
  // }
}
</style>
